import { Component, Input } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
  selector: "app-automationfield",
  templateUrl: "./automationfield.component.html",
  styleUrls: ["./automationfield.component.css"],
})
export class AutomationFieldComponent {
  @Input() name: string;
  @Input() label: string;
  @Input() tooltip?: string;
  @Input() helperText?: string;
  @Input() formGroup: FormGroup;
  @Input() options: { label: string; value: string }[] = [];
  @Input() placeholder?: string;
  @Input() type?: string;
  @Input() lastrun?: any; // Optional input for last run time
  referencePaths: string[] = [];
  filteredPaths: string[] = [];

  ngOnInit() {
    if (this.lastrun) {
      this.referencePaths = this.flattenObjectPaths(this.lastrun);
      this.filteredPaths = this.referencePaths;
      //console.log(this.referencePaths);
    }
      // Re-filter on every value change
  this.valueControl.valueChanges.subscribe(value => {
    this.filterPaths(value || '');
  });
  }

  // Form controls
  get fieldTypeControl(): FormControl {
    return this.formGroup.get("fieldType") as FormControl;
  }

  get valueControl(): FormControl {
    return this.formGroup.get("value") as FormControl;
  }

  // Type checks
  get isValue(): boolean {
    return this.fieldTypeControl.value === "Value";
  }

  get isReference(): boolean {
    return this.fieldTypeControl.value === "Reference";
  }

  get isTemplate(): boolean {
    return this.fieldTypeControl.value === "Template";
  }

  setFieldType(type: "Value" | "Reference" | "Template") {
    this.fieldTypeControl.setValue(type);
  }
filterPaths(search: string): void {
  if (!search) {
    this.filteredPaths = this.referencePaths;
    return;
  }

  this.filteredPaths = this.referencePaths.filter(path =>
    path.toLowerCase().includes(search.toLowerCase())
  );
}



private flattenObjectPaths(obj: any, prefix = 'automationData'): string[] {
  const paths: string[] = [];

  const walk = (value: any, path: string) => {
    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        walk(item, `${path}[${index}]`);
      });
    } else if (value !== null && typeof value === 'object') {
      for (const key of Object.keys(value)) {
        walk(value[key], `${path}.${key}`);
      }
    } else {
      paths.push(path);
    }
  };

  walk(obj, prefix);
  return paths;
}

}
